import { POST, postFile } from "../../index";

export const selectDriverFace = (param) => POST("/v1/driverFace/selectDriverFace", param);
export const updateDriverFace = (param) => postFile("/v1/driverFace/updateDriverFace", param);
